import React from "react";
import PropTypes from "prop-types";
import { InputField, TextareaField } from "../../FormField";

const Part6 = ({ data }) => (
  <table
    style={{
      margin: "10px 0px",
      width: "100%",
      borderCollapse: "collapse",
      border: "1px solid #000",
    }}
  >
    <tbody>
      <tr>
        <td
          style={{
            fontWeight: "bold",
            backgroundColor: "#edb8be",
            paddingLeft: 10,
            borderBottom: "1px solid #000",
          }}
        >
          VI)&nbsp;If the answer to any of the questions in Section V Is Yes, please provide with
          FULL DETAILS here.
        </td>
      </tr>
      <tr>
        <td>
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    textAlign: "center",
                    width: 100,
                  }}
                  rowSpan={2}
                >
                  Question Number
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    textAlign: "center",
                  }}
                  rowSpan={2}
                >
                  Name of Person Concerned (Employee/Spouse/Child(ren))
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    textAlign: "center",
                  }}
                  rowSpan={2}
                >
                  {[
                    "Details of Diagnostic Test with reason & result / Doctor's ",
                    "Diagnosis / lnjury / Treatment",
                  ].join("")}
                </td>
                <td
                  colSpan={2}
                  style={{
                    textAlign: "center",
                    border: "1px solid #000",
                  }}
                >
                  Duration of Illness
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "1px solid #000",
                  }}
                  rowSpan={2}
                >
                  Name of Doctor Consulted & Address of Clinic
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    textAlign: "center",
                  }}
                >
                  From
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    textAlign: "center",
                  }}
                >
                  To
                </td>
              </tr>
              {Array.of(1, 2, 3, 4).map(key => (
                <tr key={key} style={{ height: "60px" }}>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <InputField
                      name={`MoreInfoSubQNo${key}`}
                      {...data[`MoreInfoSubQNo${key}`]}
                      style={{ width: 30 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <InputField
                      name={`MoreInfoName${key}`}
                      {...data[`MoreInfoName${key}`]}
                      style={{ width: 150 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <TextareaField
                      name={`MoreInfoDiagnosis${key}`}
                      {...data[`MoreInfoDiagnosis${key}`]}
                      style={{ width: 300 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <InputField
                      name={`MoreInfoFrom${key}`}
                      {...data[`MoreInfoFrom${key}`]}
                      style={{ width: 100 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <InputField
                      name={`MoreInfoTo${key}`}
                      {...data[`MoreInfoTo${key}`]}
                      style={{ width: 100 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <TextareaField
                      name={`MoreInfoMedicalProvider${key}`}
                      {...data[`MoreInfoMedicalProvider${key}`]}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
);

Part6.propTypes = {
  data: PropTypes.shape({}),
};

export default Part6;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Ge/GEHD201808/Part6.js